export const PROFESSION_TYPES = [
  { label: 'profession.type.phc_worker', value: 'phc_worker' },
  { label: 'profession.type.therapist', value: 'therapist' }
];
